import React from "react"

export const RequestIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
            <path id="icons8-job" d="M11,4a7,7,0,1,0,7,7A7.008,7.008,0,0,0,11,4ZM5.833,13.939l1.881-1.881a3.668,3.668,0,0,1,2.495-4.778A3.61,3.61,0,0,1,11.785,7.2a.352.352,0,0,1,.19.6L10.466,9.307a1.631,1.631,0,0,0-.006,2.329,1.575,1.575,0,0,0,2.178-.047L14.2,10.025a.352.352,0,0,1,.6.19,3.61,3.61,0,0,1-.079,1.576,3.668,3.668,0,0,1-4.778,2.494L8.061,16.166A5.984,5.984,0,0,1,5.833,13.939Z" transform="translate(-4 -4)" fill="#ff8d53" />
        </svg>

    )
}